define('SuiteDynamics.PLPThreePanelBanner.Entrypoint',
	[
		'SuiteDynamics.PLPThreePanelBanner.Banner'
	],
	function (
		Banner
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			Banner.mountToApp(container);
		}
	};
});
